import { Button, Typography } from '@mui/material'
import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../store'
import { checkIfUserHasAllMandatoryInfosProfile, hasAgreedToCurrentCGU } from '../../../utils/utils'
import DefaultDialog from '../DefaultDialog'

/**
 *
 * @description guards to check cgu completion & user info conformity
 * @param {Object} props React props
 * @param {Object} props.children content wrapped in guards
 */
const GuardsWrapper = ({ children }: any) => {
    const { user, technicalConfig, address, extraHealthSystemInfo, extraHealthActivityInfo, globalConfig } =
        useAppSelector((state) => state.auth)
    const navigate = useNavigate()

    const [checkGuards, setCheckGards] = React.useState({
        hasCheckedGuards: false,
        hasUserAllMandatoryInfos: false,
        hasToValidateCGU: false,
    })

    const { hasUserAllMandatoryInfos, hasToValidateCGU, hasCheckedGuards } = checkGuards

    React.useEffect(() => {
        const getGuards = async (
            userObject: any,
            addressObject: any,
            extraHealthSystemInfoObject: any,
            extraHealthActivityInfoObject: any,
            technicalConfigObject: any,
            globalConfigObject: any
        ) => {
            const mandatoryInfosProfileResponse = await checkIfUserHasAllMandatoryInfosProfile(
                userObject,
                addressObject,
                extraHealthSystemInfoObject,
                extraHealthActivityInfoObject,
                true
            )
            const cguResponse = await hasAgreedToCurrentCGU(technicalConfigObject, globalConfigObject)

            setCheckGards({
                hasUserAllMandatoryInfos: mandatoryInfosProfileResponse,
                hasToValidateCGU: !cguResponse,
                hasCheckedGuards: true,
            })
        }

        getGuards(user, address, extraHealthSystemInfo, extraHealthActivityInfo, technicalConfig, globalConfig)
    }, [])

    // hasCheckedGuards is false on first render to prevent redirect before checks
    if (hasCheckedGuards) {
        return (
            <>
                <DefaultDialog
                    open={hasUserAllMandatoryInfos && hasToValidateCGU}
                    largePadding
                    withQuitButton={false}
                    isTiny
                    isFixedButtons
                    buttons={
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                navigate('/cgu')
                            }}
                            data-cy="btnAcceptToGoToCguPage"
                        >
                            D'accord
                        </Button>
                    }
                    title={"Conditions générales d'utilisation du service TokTokDoc"}
                >
                    <Typography>
                        Nous avons mis à jour nos Conditions Générales d&apos;Utilisation (CGU), nous vous serions
                        reconnaissants de bien vouloir en prendre connaissance afin de continuer à utiliser le service
                        TokTokDoc.
                    </Typography>
                </DefaultDialog>
                {!hasUserAllMandatoryInfos && <Navigate replace to="/account" />}
                {children}
            </>
        )
    }
    return null
}

export default GuardsWrapper
